export default __webpack_public_path__ + "7509ce73d6754920e8a71fc51fe67f2c.png";